import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject }    from 'rxjs/Subject';

@Injectable()
export class UserMsgService {

  message: {class: string, text: string};
  msgChange: Subject<any> = new Subject<any>();

  constructor() { }

  sendMessage(value: {class: string, text: string}) {
    this.message = value;
    this.msgChange.next(this.message);
  }

}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/user-msg.service.ts